<script>
import swal from "sweetalert";
import { clientService, payUService,therapistsService } from "@/services";
import RefundDialog from "./RefundDialog.vue";
import * as dayjs from "dayjs";
import VisitEditor from "../visits/VisitEditor.vue";

export default {
  name: "payu",
  data() {
    return {
      items: [],
      options: {},
      pagination: {},
      totalCount: 0,
      selected_client: null,
      isLoadingClients: false,
      clientKeyword: null,
      clientTimerId: 0,
      clientsList: [],
      max_refund: 0,
      visible_new_refund: false,
      selected_order_id: 0,
      startDate: null,
      endDate: null,
      editorData: null,
      showVisitEditor: false,
      startDateMenu: false,
      endDateMenu: false,
      headers: [
        { text: 'Klient', sortable: true, align: 'left', value: 'clientName' },
        { text: 'Data wizyty', sortable: true, align: 'left', value: 'visitDate' },
        { text: 'Pracownik', sortable: false, align: 'left', value: 'therapistName' },
        { text: 'Status', sortable: false, align: 'left', value: 'status' },
        { text: 'Cena', sortable: false, align: 'left', value: 'amount' },
        { text: 'Data płatności', sortable: false, align: 'left', value: 'paymentDate' },
        { text: 'Data zwrotu', sortable: false, align: 'left', value: 'refundDate' },
        { text: 'Kto zwrócił?', sortable: false, align: 'left', value: 'userRefunded' },
        { text: 'Akcje', sortable: false, align: 'left', value: 'orderId' }
      ],
      loading: false,
      typywizyt: [],
      pakiety: [],
      statusy: ['Nowa','Oczekująca','Oczekująca na potwierdzenie','Opłacona','Anulowana','Zwrócona'],
      selectedStatus: null
    }
  },
  components: {
    RefundDialog, VisitEditor
  },
  watch: {
    options: {
      handler() {
        this.getData()
      },
      deep: true,
    },
    clientKeyword(val) {
      if (val) {
        this.fetchClientDebaunce();
      }
    },
    selected_client(val) {
      if (val) {
        this.startDate = null;
        this.endDate = null;
      }
    }
  },
  mounted() {

    this.getAllTypyWizyt()
  },
  methods: {
    getAllTypyWizyt() {      
      therapistsService.GetWszystkieTypyWizyt().then(result => {
        this.typywizyt = result.data.result
      }).catch(() => {
        this.error("Nie można pobrać typów wizyt terapeutów.");
      })
    },
    editVisit(id) {
      this.showVisitEditor = true
      this.editorData = { Id: id }
    },
    showError(text) {
      swal({
        title: "Błąd",
        text: text,
        icon: "warning",
        button: "OK"
      }).then(() => {

      });
    },
    getFormattedDate(val) {

      if (val) {
        let dj = dayjs(val)

        if (dj != null) {
          return dj.format("DD-MM-YYYY HH:mm")
        } else {
          return ''
        }
      }
      return ''
    },
    refreshInfo(id) {
      payUService.getPaymentDetails(id).then(() => {
        this.getData()
      }).catch(() => {
        this.showError('Bład odświeżania informacji o płatności')
      })
    },
    closeNewRefund() {
      this.max_refund = 0
      this.selected_order_id = 0
      this.visible_new_refund = false
    },
    saveNewRefund(data) {
      var orderId = this.selected_order_id
      this.selected_order_id = 0
      this.max_refund = 0
      this.visible_new_refund = false


      payUService.refundPayment({ orderId: orderId, amount: data.refundAmount, reason: data.reason }).then(() => {
        this.getData()
      }).catch((error) => {
        let err = error.response
        if (err.data != null && err.data.error && err.data.error.message) {
          this.showError(err.data.error.message)
        } else {
          this.showError("Nie można zwrócić płatności")
        }
      })
    },
    getData() {
      const { sortBy, sortDesc, page, itemsPerPage } = this.options
      let sortValue = ''
      if (sortBy.length > 0) {
        sortValue = sortBy[0]
        if (sortDesc.length > 0)
          sortValue = sortBy[0] + (sortDesc[0] ? " DESC" : "");
      }      
      this.loading = true
      payUService.getPayUPayments({
        Sorting: sortValue,
        SkipCount: (page - 1) * itemsPerPage,
        MaxResultCount: itemsPerPage,
        client_id: this.selected_client !== null ? this.selected_client.id : null,
        poczatek: this.startDate,
        koniec: this.endDate,
        status: this.selectedStatus
      }).then(result => {
        this.pakiety = result.data.result.items
        this.totalCount = result.data.result.totalCount
        this.loading = false
      }).catch(() => {
        this.showError('Bład pobierania pakietów recept')
        this.loading = false
      })
    },
    refund(item) {

      this.selected_order_id = item.orderId;
      this.max_refund = item.amount
      this.visible_new_refund = true
    },
    getClientValues() {
      this.isLoadingClients = true;
      clientService
        .getAll({ query: this.clientKeyword, page: 1, limit: 20, sorting: "surname" })
        .then(data => {
          data.data.result.items.forEach(item => {
            if (!this.clientsList.find(x => x.id === item.id)) {
              let name = item.name + " " + item.surname;
              this.clientsList.push({
                id: item.id,
                name: name
              });
            }
          });
          this.isLoadingClients = false;
        })
        .catch(() => {
          this.isLoadingClients = false;
          this.showError("Nie można pobrać listy klientów.");
        });
    },
    fetchClientDebaunce() {
      // cancel pending call
      clearTimeout(this.clientTimerId)
      // delay new call 500ms
      this.clientTimerId = setTimeout(() => {
        this.getClientValues()
      }, 500)
    },
  }
}
</script>

<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-card>
                    <v-card-title>
                      Wyszukiwanie
                    </v-card-title>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" lg="6" md="6" sm="12">
                            <v-autocomplete v-model="selected_client" :loading="isLoadingClients" :items="clientsList"
                              :search-input.sync="clientKeyword" cache-items flat no-data-text="Nieznaleziono"
                              hide-details return-object item-text="name" item-value="id" clearable
                              label="Wyszukaj pacjenta Imię/Nazwisko/PESEL">
                            </v-autocomplete>
                          </v-col>
                          <v-col cols="12" lg="3" md="6" sm="12">
                            <v-menu ref="startDateMenu" v-model="startDateMenu" :close-on-content-click="false"
                              :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="startDate" label="Data początkowa" prepend-icon="fa fa-calendar"
                                  readonly clearable v-bind="attrs" v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="startDate" @input="startDateMenu = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" lg="3" md="6" sm="12">
                            <v-menu ref="endDateMenu" v-model="endDateMenu" :close-on-content-click="false"
                              :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field v-model="endDate" label="Data końcowa" prepend-icon="fa fa-calendar"
                                  readonly clearable v-bind="attrs" v-on="on"></v-text-field>
                              </template>
                              <v-date-picker v-model="endDate" @input="endDateMenu = false"></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" lg="3" md="6" sm="12">
                            <v-select v-model="selectedStatus" :items="statusy" label="Status" clearable></v-select>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="success" @click="getData()">Szukaj</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-data-table :headers="headers" :items="pakiety" :options.sync="options"
                    :server-items-length="totalCount" :loading="loading"
                    :footer-props="{ itemsPerPageOptions: [50, 100, 200, 500], }" class="elevation-1">
                    <template v-slot:item="props">
                      <tr>
                        <td>{{ props.item.clientName }}</td>
                        <td>{{ getFormattedDate(props.item.visitDate) }}</td>
                        <td>{{ props.item.therapistName }}</td>
                        <td>{{ props.item.status }}</td>
                        <td>{{ props.item.amount }}</td>
                        <td>{{ getFormattedDate(props.item.paymentDate) }}</td>
                        <td>{{ getFormattedDate(props.item.refundDate) }}</td>
                        <td>{{ props.item.userRefunded }}</td>
                        <td>
                          <v-icon small class="mr-2" @click="refreshInfo(props.item.orderId)" color="primary"
                            title="Odśwież szczegóły płatności">fa-sync</v-icon>
                            <v-icon small class="mr-2" @click="editVisit(props.item.visitId)" v-if="$can('do','POKO_Wizyty_Edycja')" title="Edytuj wizyte">fa-user-edit</v-icon>                          
                        </td>
                      </tr>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <RefundDialog v-if="visible_new_refund" :max-refund="max_refund" :visible="visible_new_refund"
          @close="closeNewRefund" @save="saveNewRefund"></RefundDialog>
      </v-col>
    </v-row>
    <v-row>      
      <VisitEditor :visitData="editorData" :visible="showVisitEditor" v-if="showVisitEditor"
        @close="showVisitEditor = false" :typywizyt="typywizyt" :hidevisithistory="false"></VisitEditor>
    </v-row>
  </v-container>
</template>

<style scoped></style>